export function equalHeight(selector) {
  const elements = document.querySelectorAll(selector);

  if (!elements.length) return;

  // Reset heights
  elements.forEach((el) => {
    el.style.height = "auto";
  });

  const rows = new Map();

  elements.forEach((el) => {
    const top = Math.round(el.getBoundingClientRect().top);

    if (!rows.has(top)) {
      rows.set(top, []);
    }

    rows.get(top).push(el);
  });

  rows.forEach((row) => {
    let maxHeight = 0;

    row.forEach((el) => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    row.forEach((el) => {
      el.style.height = `${maxHeight}px`;
    });
  });
}